import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { type StateCountry } from './state-country.type';
import { filter, pipe, switchMap, tap } from 'rxjs';
import { StateCountryService } from './state-country.service';
import { tapResponse } from '@ngrx/operators';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { setError, setLoaded, setLoading, withCallState } from '@ngrx-toolkit/core';

type State = {
  states: Array<StateCountry>;
};

const initialState: State = {
  states: [],
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const StateCountryStoreFactory = () =>
  signalStore(
    { providedIn: 'root' },
    withState(initialState),
    withCallState(),
    withMethods((store, api = inject(StateCountryService)) => ({
      load: rxMethod<void>(
        pipe(
          filter(() => !store.loaded()),
          tap(() => patchState(store, setLoading())),
          switchMap(() =>
            api.load().pipe(
              tapResponse({
                next: (states) => patchState(store, { states }, setLoaded()),
                error: (error) => patchState(store, setError(error)),
              }),
            ),
          ),
        ),
      ),
    })),
  );

export const StateCountryStore: ReturnType<typeof StateCountryStoreFactory> = StateCountryStoreFactory();
